import { 
  Typography,  
  Box ,
  ToggleButton,
} from "@mui/material";
import "../common/css/dashboard.css";

const HeaderQuickMenu = (props) => {  

  return (

    <Box 
    >
      <ToggleButton
        color="primary"
        value="check" 
        onClick={() => window.open(("/rentmember/company/MemberJoin"), '_blank')}
        sx={{ border:0 ,  m:0.2, p:0}}
      >
      {/* <IconDeviceDesktop style={{ color: "#7478e8" }} /> */}
      <Typography 
        variant="h8"    
        sx={{           
          color: "#fff", 
          bgcolor: "#1d4b75",          
          //bgcolor: "#0000a7", 
          fontSize: '15px',
          width:'220px',
          height:'38px',    
          borderRadius:8,
          display: 'flex',           // flex 사용
          alignItems: 'center',       // 세로 중앙 정렬
          justifyContent: 'center',   // 가로 중앙 정렬
          textAlign: 'center',        // 텍스트 중앙 정렬 (백업)
          '&:hover': {
            // backgroundColor: '#5454c3',  // 마우스 오버 시 보라
            backgroundColor: '#2180aa',  // 마우스 오버 시 군청       
            // backgroundColor: '#2221aa',  // 마우스 오버 시 군청      
          },
        }}
      >         
        회원가입 신청
      </Typography>
    </ToggleButton>
  </Box>
  );
};

export default HeaderQuickMenu;
